import { createSvgIcon } from '@mui/material';
import { ReactComponent as Icon } from 'assets/customIcons/word.svg';

const WordIcon = createSvgIcon(<Icon />, 'Pdf');

export default WordIcon;
